import type { RemoteConfigApp } from 'src/constants/remote-config/remoteConfig'
import type { RemoteConfig } from 'src/interfaces/remoteConfig'

/** One app's keys matching the search in key or description, sorted by key. */
export const filterRemoteConfigs = (
  remoteConfigs: RemoteConfig[],
  app: RemoteConfigApp,
  search: string,
): RemoteConfig[] => {
  const normalizedSearch = search.trim().toLowerCase()

  // `filter` returns a new array, so the sort never touches the stored one.
  return remoteConfigs
    .filter((remoteConfig) => {
      if (remoteConfig.app !== app) {
        return false
      }

      if (normalizedSearch === '') {
        return true
      }

      return (
        remoteConfig.key.toLowerCase().includes(normalizedSearch) ||
        remoteConfig.description.toLowerCase().includes(normalizedSearch)
      )
    })
    .sort((left, right) => {
      return left.key.localeCompare(right.key)
    })
}

export const countRemoteConfigsByApp = (
  remoteConfigs: RemoteConfig[],
  app: RemoteConfigApp,
): number => {
  return remoteConfigs.filter((remoteConfig) => {
    return remoteConfig.app === app
  }).length
}
